import { get } from './request'
import { getItemSync, setItemSync } from '../cache'
import { getUin } from '../user';
import { addUrlParam } from '../url';

/**
 * 加载vtools文件
 * @param url
 * @param expire
 * @returns {*}
 */
export function loadVtools(url, expire = 0) {
    const cacheKey = getUin() + url;
    if (expire) {
        const cacheResult = getItemSync(cacheKey);
        if (cacheResult) return Promise.resolve(cacheResult);
    }

    const gap = url.indexOf('?') > -1 ? '&' : '?'
    let p = get(url + gap + 'v=' + (new Date()));

    p = p.then(res => {
        return res.data;
    });

    p = p.then(data => {
        if (expire) {
            setItemSync(cacheKey, data, expire);
        }
        return data;
    });
    return p;
}

/**
 * 加载配置文件
 * @param {string} url 配置url
 * @param {boolean} isIgnoreHttpCache 是否忽略http缓存，默认false（为true时请求会携带随机参数，每次都下载最新配置）
 * @returns {*}
 */
export async function loadConfig(url, isIgnoreHttpCache) {
    let reqUrl = url;
    if(isIgnoreHttpCache) {
        reqUrl = addUrlParam(reqUrl, 'v', new Date());
    }
    return await get(reqUrl);
}